<template>
    <div class="footer mt-6">
        <div class="container">
            <div class="row py-4">
                <div class="v-col-12">
                    <v-divider></v-divider>
                </div>
                <div class="v-col-sm-12 v-col-md-6 v-col-lg-4 text-center">
                    <div class="w-100">
                        <p class="d-flex text-md-start justify-center w-100 h-100">
                            <Link :href="route('home.index')">
                                <img class="image-logo" :src="themes?.logo ? getImage(themes?.logo) : '/assets/img/logo.png'" width="" height="40" alt="image-logo">
                            </Link>

                        </p>
<!--                        <p class="text-grey-darken-1 d-flex justify-content-center w-100">{{ themes.site_description }}</p>-->
                    </div>
                </div>
                <div class="d-none d-lg-block col-md-12 v-col-lg-4 text-center">
                    <p class="text-grey-darken-1 fs-14">{{ themes?.slogan }}</p>
                </div>
                <div class="v-col-sm-12 v-col-md-6 v-col-lg-4 text-center">
                    <ul class="list-unstyled d-inline-flex mb-1">
                        <li class="mt-2">
                            <Link :href="route('page', 'contact-us')">
                                <h5 class="text-grey-darken-1">ទំនាក់ទំនងយើង</h5>
                            </Link>
                        </li>
                    </ul>
                    <p class="fs-14 text-grey-darken-1">{{ themes?.copyright_name }}</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>

import { computed } from "vue";
import { Link, usePage} from "@inertiajs/vue3";

const themes = computed(() => usePage().props.themes);

</script>

<style scoped>

</style>
